<template>
  <div class="anchor-sidebar d-none d-md-block">
    <ul class="sidebar overflow-auto h-100">
      <li
        v-for="item in items"
        :key="item.text"
        class="sidebar__item"
      >
        <router-link
          :to="item.route"
          class="sidebar__item__link"
          :exact="item.exact"
        >
          <FontAwesomeIcon
            :icon="item.icon"
            class="sidebar__item__link__icon"
          />
          {{ item.text }}
        </router-link>
      </li>
      <hr/>
      <AnchorTeam />
    </ul>
  </div>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faAddressCard,
  faHandshake,
  faCheckCircle,
  faPlus,
  faChevronDown,
  faBars,
  faTimes,
  faCopy,
  faSlidersH,
  faListUl,
} from '@fortawesome/free-solid-svg-icons';
import ICONS from '@/assets/icons/icons';
import perms from '@/libs/permissions';

import navigationLinks from '@/components/base/navbar/resources';
import AnchorTeam from '@/components/base/sidebar/AnchorTeam';

library.add([
  faAddressCard,
  faHandshake,
  faCheckCircle,
  faPlus,
  faChevronDown,
  faBars,
  faTimes,
  faCopy,
  faSlidersH,
  faListUl,
  ICONS.faPlaidIcon,
]);


export default {
  name: 'AnchorSidebar',
  components: {
    AnchorTeam,
    FontAwesomeIcon,
  },
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    this.items = navigationLinks.userItems.filter(item => perms.checkPermissions(item.permissions));
  },
};
</script>
<style scoped>
.anchor-sidebar{
  --primary-color: #5C7182;
  --sidebar-item-hover-color: #E1F0FF;

  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  padding-top: 90px;
  width: var(--app-sidebar-width);
  background-color: #ffffff;
  margin-top: 15px;
}

.sidebar{
  list-style: none;
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline-start: 0;
}

.sidebar__item__link{
  display: block;
  color: var(--primary-color);
  text-decoration: none;
  padding: .7rem 1.2rem .7rem 2rem;
  font-weight: 400;
  font-size: 20px;
  line-height: 22px;
  cursor: pointer;
}
.sidebar__item__link:hover, .router-link-active {
  background-color: var(--sidebar-item-hover-color);
}

.sidebar__item__link__icon{
  width: 1rem;
  height: 1rem;
  margin-right: .5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/base/sidebar/AnchorSidebar.vue